import React from "react"
import useScrollDirection from "./UseScrollDirection"

export const Header = () => {
  const direction = useScrollDirection()

  return (
    <div
      className={
        "bg-white w-full px-3 md:px-10 top-0 z-10 flex justify-between sticky nav items-center py-1 md:py-0 " +
        (direction === "up" ? "nav-up" : "nav-down")
      }
    >
      <a href="/" title="Go to home page">
        <img
          alt="Newslaundry logo"
          className="header-logo"
          src="https://images.assettype.com/newslaundry/2020-01/d91cad07-9650-47e9-8bdc-9a6247354d95/Header_logo_NL__2_New.png"
        ></img>
      </a>
      {/* <a
        href="http://newslaundry.com/subscription"
        className="p-1 my-1 font-bold text-xs md:text-lg border-2 border-gray-600 tracking-wider"
        target="__blank"
      >
        SUBSCRIBE
      </a> */}
    </div>
  )
}
